// Dashboard Requests
export const GetAllDashBoardDetailsUrl =
  'api/Operations/DashBoard/GetDashBoardDetails';
export const GetAllDashBoardDetailsForSpecificDayUrl =
  'api/Operations/DashBoard/GetDashBoardDetailsForSpecificDay';
